export type HeaderVariant =
  "default" | "calendar-uplift" | "inbox-v2" | "paid-social" | "posts";

export const resolveHeaderHeight = ({
  variant = "default",
  wide,
}: {
  variant?: HeaderVariant;
  wide: boolean;
}): string => {
  if (variant === "calendar-uplift") return "56px";
  if (variant === "paid-social") return "56px";
  if (variant === "posts") return "48px";
  return wide ? "60px" : "50px";
};
